$(function() {
	$("._bar").each(function(){
		var alert_bar = $(this);
		var alerts = $(this).find('.alert');
		var alert_inner = $(this).find('alert_inner');
		var prev_alert = $(this).find('.prev_alert');
		var next_alert = $(this).find('.next_alert');

		if (!alerts.length)
			return;

		var height = 54;
		var autoplay = null;
		// if ($('body').hasClass('admin-bar'))
		// 	height = 45;

		var shownIndex = 0;
		alerts.eq(shownIndex).addClass('show').attr('tabindex', '0');


		$(window).scroll(function() {
			var scrollTop = $(window).scrollTop();
			var offset = height - Math.min(scrollTop, height);

			$('.site_container > header').css('transform', 'translateY(' + offset + 'px)');
		});

		alert_bar.focusin(function(){
			clearInterval(autoplay);
		});

		prev_alert.on( "click change", function(e) {
			clearInterval(autoplay);
			shownIndex -= 1;
			if (shownIndex < 0)
				shownIndex = alerts.length-1;

			alerts.removeClass('show').attr('tabindex', -1).eq(shownIndex).addClass('show').attr('tabindex', '0');
			if (e.originalEvent !== undefined)
				alert_bar.find('.show').focus();
		});

		next_alert.on( "click change", function(e) {
			if (!e.isTrigger)
				clearInterval(autoplay);

			shownIndex += 1;
			if (shownIndex > alerts.length-1)
				shownIndex = 0;

			alerts.removeClass('show').attr('tabindex', -1).eq(shownIndex).addClass('show').attr('tabindex', '0');
			if (e.originalEvent !== undefined)
				alert_bar.find('.show').focus();
		});

		var sizeAlerts = function() {
			var maxWidth = 0;
			alerts.each(function() {
				maxWidth = Math.max(maxWidth, $(this).width());
			});
			$('.alert_bar .alert_inner').width(maxWidth);
		}

		$(window).load(function() {
			$('body').addClass('reveal_alerts');
			sizeAlerts();
			setTimeout(function() {
				$('.site_container > header').addClass('alerts_revealed');
			}, 500);

			if (alerts.length > 1) {
				autoplay = setInterval(function() {
					if(alert_bar.hasClass("visible")){
						if (window.currentSlidersState == 2)
							return clearInterval(autoplay)
						next_alert.trigger('change');
					}
				}, 4500);
			}
		});

	});

	// var interval = setInterval(function() {
	// 	if ($('body').hasClass('load_step_2')) {
	// 		clearInterval(interval);
	// 		$('body').addClass('reveal_alerts');
	// 		sizeAlerts();
	// 		setTimeout(function() {
	// 			$('header').addClass('alerts_revealed');
	// 		}, 500);
	// 	}
	// }, 50);

});